import { FC } from 'react';
import { styled } from '@mui/system';
import { CircularProgress, Paper } from '@mui/material';

const LoadingContainer = styled(Paper)(() => ({
   width: '100%',
   height: '100vh',
   display: 'flex',
   alignItems: 'center',
   justifyContent: 'center'
}))

const Loading: FC = () => {
   return (
      <LoadingContainer>
         <CircularProgress />
      </LoadingContainer>
   );
};

export default Loading;